import { useState } from 'react';

import {ObjaveIcon, KategorijeIcon, UserIcon} from '../../shared/icon/TablerIcon';

import HamMenu from './HamMenu';
// import { authActions } from 'src/store/login-store';
import { Link } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import { userLogout } from 'src/store/login-store';
import { useAppDispatch } from 'src/store';

export const navItems = [
  {
    text: 'Objave',
    href: './objave',
    icon: <ObjaveIcon/>
  },
  {
    text: 'Kategorije',
    href: './kategorije',
    icon: <KategorijeIcon/>
  },
];

const Nav = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useAppDispatch();

  const logoutHabndler = () => {
    dispatch(userLogout());
  }

  return (
    <>
      <header className="page-header page-header-border">
        <div className="container-lg px-3 d-flex flex-row justify-content-between align-items-center">
          <div className='d-flex'>
            <Link to='./'>
            <img className='img-logo-cg' src='/logo-cg-full.svg'/>
            </Link>
            <ul className="d-none d-lg-flex align-items-center m-0 list-unstyled gap-4">
              {navItems.map((prod, index) => (
                <li key={index}>
                  <NavLink className='nav-prostorno' to={prod.href} style={({ isActive }) => ({ color: isActive ? 'rgb(90, 90, 90)' : 'unset', textDecoration: 'none', })}>{prod.icon}{prod.text}</NavLink>
                </li>
              ))}
            </ul>
          </div>

          <div className="d-flex gap-3 align-items-center">
            <div className="dropdown">
              <div className="d-flex dropdown-toggle align-items-center cursor-pointer" data-bs-toggle="dropdown">
              <UserIcon/>

                <div className="d-flex flex-column ">
                  <p className="m-0"></p>
                  <p className="m-0"></p>
                </div>
              </div>
              <div className="dropdown-menu">
                <button onClick={logoutHabndler} className="dropdown-item">
                  Logout
                </button>
              </div>
            </div>

            <button
              onClick={() => setIsOpen((state) => !state)}
              className="d-lg-none d-flex flex-column justify-content-between bg-transparent border-0"
              style={{
                height: 18,
                width: 24,
              }}>
              <span
                className="h-px w-full bg-black d-block"
                style={{
                  transition: '0.4s',
                  transform: isOpen ? 'translateY(8.5px) rotate(45deg)' : '',
                }}></span>
              <span
                className="h-px w-full bg-black d-block"
                style={{
                  transition: '0.3s',
                  transform: isOpen ? 'scaleX(0)' : '',
                }}></span>
              <span
                className="h-px w-full bg-black d-block"
                style={{
                  transition: '0.4s',
                  transform: isOpen ? 'translateY(-8.5px) rotate(-45deg)' : '',
                }}></span>
            </button>
          </div>
        </div>
      </header>

      <HamMenu isOpen={isOpen} closeMenu={() => setIsOpen(false)} />

      
    </>
  );
};

export default Nav;
